import { Component, OnInit } from '@angular/core';
import { IsNotCalibratedReasonService } from 'src/app/core/services/is-not-calibrated-reason.service';
import IIsNotCalibratedReason = ZoneIQCalibration.IIsNotCalibratedReason;
import { CommonService } from 'src/shared/services/common.service';
import * as _ from 'lodash';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/shared/zoneiqui/components/confirmation-dialog/confirmation-dialog.component';
import { IINCREditData, IncrEditPopupComponent } from './incr-edit-popup/incr-edit-popup.component';
import { Observable } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    standalone: false,
    selector: 'app-is-not-calibrated-reasons-management-page',
    templateUrl: './is-not-calibrated-reasons-management-page.component.html',
    styleUrls: ['./is-not-calibrated-reasons-management-page.component.scss']

})
export class IsNotCalibratedReasonsManagementPageComponent implements OnInit {
    activeRecord: IIsNotCalibratedReason;
    originalRecord: IIsNotCalibratedReason;
    activeRecordIndex: number;

    constructor(
        private isNotCalibratedReasonService: IsNotCalibratedReasonService,
        private commonService: CommonService,
        private readonly dialog: MatDialog
    ) {}

    tableFields = ['', 'Reason', 'Default', 'Actions'];

    get reasons$(): Observable<IIsNotCalibratedReason[]> {
        return this.isNotCalibratedReasonService.isNotCalibratedReasons.asObservable();
    }

    get isValidRecord() {
        return this.activeRecord && this.commonService.checkEmptyString(this.activeRecord.Reason);
    }

    ngOnInit(): void {}

    isSelectedRecord(record: IIsNotCalibratedReason): boolean {
        return record === this.activeRecord;
    }

    setActiveRecord(index: number, reason: IIsNotCalibratedReason) {
        if (!this.commonService.checkEmptyString(reason.Reason) || this.activeRecord === reason) {
            return;
        }
        this.activeRecord = reason;
        this.originalRecord = _.pick(reason, ['Reason', 'IsDefault', 'Order']);

        this.activeRecordIndex = index;
    }

    blurHandler(_target) {
        if (!this.activeRecord) {
            return;
        }

        if (this.isValidRecord) {
            this.saveRecordModification();
        } else {
            this.setOriginValue();
        }
    }

    saveRecordModification() {
        if (!this.activeRecord) {
            return;
        }
        const cleanValue = this.activeRecord.Reason.trim();
        if (cleanValue.length > 1) {
            this.activeRecord.Reason = cleanValue;
            this.isNotCalibratedReasonService.updatedIsNotCalibratedReason(this.activeRecord).subscribe();
            this.clearSelection();
        }
    }

    setOriginValue() {
        if (!this.activeRecord || !this.originalRecord) {
            return;
        }

        Object.assign(this.activeRecord, this.originalRecord);
        this.clearSelection();
    }

    clearSelection() {
        this.activeRecordIndex = null;
        this.activeRecord = null;
        this.originalRecord = null;
    }

    editRecord(reason: IIsNotCalibratedReason) {
        const data: IINCREditData = {
            record: reason,
            existingRecords: this.isNotCalibratedReasonService.isNotCalibratedReasons.value
        };
        this.dialog.open(IncrEditPopupComponent, {
            width: '400px',
            data
        });
    }

    deleteRecord(reasonId: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Delete Is Not Calibrated Reason',
            topContent: `Current Is Not Calibrated Reason will be deleted. Continue?`
        };
        const deleteUseRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        deleteUseRef.afterClosed().subscribe(needToDelete => {
            if (!needToDelete) {
                return;
            }
            this.isNotCalibratedReasonService.deleteIsNotCalibratedReason(reasonId).subscribe();
        });
    }

    createReason() {
        const data: IINCREditData = {
            record: null,
            existingRecords: this.isNotCalibratedReasonService.isNotCalibratedReasons.value
        };
        this.dialog.open(IncrEditPopupComponent, {
            width: '400px',
            data
        });
    }

    cancelRecordEdit() {
        this.setOriginValue();
    }

    dropReason(event: CdkDragDrop<IIsNotCalibratedReason[]>) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }

        const updatedReasons = [...this.isNotCalibratedReasonService.isNotCalibratedReasons.value];
        moveItemInArray(updatedReasons, event.previousIndex, event.currentIndex);

        this.clearSelection();
        this.isNotCalibratedReasonService.reorderIsNotCalibratedReasons(updatedReasons).subscribe();
    }
}
